import { FC } from "react";
import svgIcons from "../../../assets/svg/svgIcons";

type SwitchChartButtonProps = {
  onClick: () => void;
};

const SwitchChartButton: FC<SwitchChartButtonProps> = ({ onClick }) => {
  return (
    <button
      className="group no-print absolute top-0 right-0 w-6 h-6 rounded-full bg-accent-blue-pale hover:bg-accent-blue-dark z-10"
      onClick={onClick}
    >
      <img
        src={svgIcons.ChartIcon}
        alt="chart"
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 group-enabled:group-hover:grayscale-0 group-enabled:group-hover:brightness-0 group-enabled:group-hover:invert"
      />
    </button>
  );
};
export default SwitchChartButton;
